import { useQuery } from '@tanstack/react-query';
import { workQueries } from './works.queries';

export function useWorks(projectId?: number, options?: { suspense?: boolean }) {
  return useQuery({
    ...workQueries.list(projectId),
    ...options,
  });
}

export function useWork(
  workId?: number | null,
  options?: { suspense?: boolean },
) {
  return useQuery({
    ...workQueries.detail(workId || 0),
    enabled: !!workId,
    ...options,
  });
}
